export default __webpack_public_path__ + "static/media/Group 1333.60aaeacf.svg";